import styles from 'views/widgets/Input/CheckBox.css';
import React, { PropTypes, Component } from 'react';
export default class CheckBox extends Component {
  static propTypes = {
    checked: PropTypes.bool
  }
  componentDidMount () {
    setTimeout(() => {
      this.refs.checkbox.checked = this.props.checked;
    }, 100);
  }

  componentDidUpdate () {
    console.log('set checked property,', this.refs.checkbox, this.props.checked);
    setTimeout(() => {
      this.refs.checkbox.checked = this.props.checked;
    }, 100);
  }

  render () {
    return (
      <span className={styles.wrapper}>
        <input
          ref='checkbox'
          type='checkbox'
          {...this.props}/>
      </span>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/widgets/Input/CheckBox.js
 **/